import { defineStyle } from '@chakra-ui/react';

export const contextMenuVariant = defineStyle({
  width: '100%',
  height: '48px',
  paddingX: '14px',
  borderRadius: 0,
  border: '2px solid transparent',
  textStyle: 'screenStd',
  backgroundColor: 'neutral.900-op80',
  '&[data-has-solid-bg="true"]': {
    backgroundColor: 'neutral.900',
  },
  boxShadow: 'none',
  justifyContent: 'start',
  '& svg': {
    color: 'neutral.300',
  },
  _focusVisible: { boxShadow: 'none' },
  '&[data-selected="true"], &[data-active="true"]': {
    borderColor: 'blue',
    backgroundColor: 'blue',
    color: 'neutral.white',
    '& svg': {
      color: 'neutral.white',
    },
  },
  _disabled: {
    opacity: 1,
    cursor: 'default',
    backgroundColor: 'neutral.900-op80',
    borderColor: 'transparent',
    '&:not([data-selected="true"]):not([data-active="true"])': {
      color: 'neutral.300',
    },
  },
  '&:hover:not(:disabled)': {
    borderColor: 'skyBlue',
    '&:not([data-selected="true"]):not([data-active="true"]):not(:disabled)': {
      backgroundColor: 'neutral.700',
      '& svg': {
        color: 'neutral.200',
      },
    },
  },
});
